import { MINI_HEADER_ID } from "./stickyHeader.const"

export const getStickyHeaderHeight = () =>
  document.getElementById(MINI_HEADER_ID)?.offsetHeight ?? 0
